import { render, staticRenderFns } from "./PalletBom.vue?vue&type=template&id=10f52162&scoped=true"
import script from "./PalletBom.vue?vue&type=script&lang=js"
export * from "./PalletBom.vue?vue&type=script&lang=js"
import style0 from "./PalletBom.vue?vue&type=style&index=0&id=10f52162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f52162",
  null
  
)

export default component.exports